const state = {
  nav: [
    {
      label: "Deployment Info",
      feature: "deployment_info",
      route: "DeploymentInfo",
      adminOnly: true
    },
    {
      label: "Tenant Overview",
      feature: "tenant_overview",
      route: "TenantOverview",
      adminOnly: true
    },
    {
      label: "Admin Logs",
      feature: "admin_logs",
      route: "AdminLogs",
      adminOnly: true
    },
    {
      label: "SuperUser",
      superOnly: true,
      subnav: [
        {
          label: "Connections",
          feature: "rabbitmq",
          route: "RabbitMQ",
        },
        {
          label: "Site Config",
          feature: "site_config",
          route: "SiteConfig",
        },
        {
          label: "System Messages",
          feature: "system_messages",
          route: "SystemMessages",
        },
      ]
    },
  ]
};
const getters = {
  administrationNav: state => state.nav
};

export default {
  state,
  getters
};
